import { TranslatableText } from '@dreryk/react-common';

import { assertUnreachable } from '~libs.typescript';
import { AdditionalEntitlement, hasAdditionalEntitlementType } from '~libs.shared.prescription';

import { prescriptionsTranslationKeys } from '../../../../../translations';

export const getModalContent = (additionalEntitlements: AdditionalEntitlement[]): TranslatableText => {
   if (hasAdditionalEntitlementType('S', additionalEntitlements)) {
      return prescriptionsTranslationKeys.prescriptionHistoryDownloadVerification.prescriptionForSeniorVerification;
   }

   if (hasAdditionalEntitlementType('DZ', additionalEntitlements)) {
      return prescriptionsTranslationKeys.prescriptionHistoryDownloadVerification.prescriptionForJuvenileVerification;
   }

   return assertUnreachable(undefined);
};
